// A one-tap step, up or down. Lifted from the Andon app's `ui/Nudge`.
//
// The close sheet nudges a stop timestamp by five minutes with it. One
// control rather than a stepper per caller, because two copies of "a small
// square with a caret in it" drift — the one that drifted being whichever got
// restyled second.
//
// A ROTATED CARET, NOT A MINUS.
//
// The icon set has no minus and no plus-in-a-box, and inventing one here would
// be a glyph that exists in one component. Two carets pointing at each other
// read unambiguously as "step this", which is what the control does; the
// number between them says where it has got to.

import { Icon } from './Icon';

export function Nudge({
  label,
  onClick,
  dir,
  disabled = false,
  size = 26,
}: {
  /** Spoken label. Says what the tap DOES, not which way the arrow points. */
  label: string;
  onClick: () => void;
  dir: 'up' | 'down';
  disabled?: boolean;
  /** 26 in the close sheet's tight two-up row; 38 where it is the main control. */
  size?: number;
}) {
  return (
    <button
      type="button"
      aria-label={label}
      onClick={onClick}
      disabled={disabled}
      style={{
        width: size,
        height: size,
        flex: 'none',
        borderRadius: size > 30 ? 12 : 8,
        border: '1px solid var(--line)',
        background: 'var(--surface2)',
        color: 'var(--ink)',
        display: 'grid',
        placeItems: 'center',
        cursor: disabled ? 'default' : 'pointer',
        opacity: disabled ? 0.4 : 1,
        padding: 0,
        transform: dir === 'up' ? 'rotate(180deg)' : undefined,
      }}
    >
      <Icon name="caret" size={size > 30 ? 16 : 12} strokeWidth={2.4} />
    </button>
  );
}
